import { useEffect, useRef, useState } from 'react';

/**
 * "Updated hh:mm:ss" beside a list's header (since 2026-10-25, API Logs and Audit Logs), so a
 * Filter click that brings nothing new still visibly re-read the list. Pass the page's useApiData
 * `loading`; the time is stamped when each load finishes.
 */
export function LastUpdated({ loading }: { loading: boolean }) {
  const [loadedAt, setLoadedAt] = useState<Date | null>(null);
  const wasLoading = useRef(loading);

  useEffect(() => {
    if (wasLoading.current && !loading) setLoadedAt(new Date());
    wasLoading.current = loading;
  }, [loading]);

  if (loading && loadedAt) {
    return (
      <small className="text-body-secondary text-nowrap" aria-live="polite">
        <span className="spinner-border spinner-border-sm me-1" aria-hidden="true" />
        Updating…
      </small>
    );
  }
  if (!loadedAt) return null;
  return (
    <small className="text-body-secondary text-nowrap" aria-live="polite">
      Updated {loadedAt.toLocaleTimeString()}
    </small>
  );
}
